import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'counterFormat',
  pure: true,
  standalone: true,
})
export class CounterFormatPipe implements PipeTransform {
  constructor() {}
  transform(num: any, args?: any): any {
    if (num) {
      if (num < 1e3) return num;
      if (num >= 1e3 && num < 1e6) return +(num / 1e3).toFixed(1) + 'K';
      if (num >= 1e6 && num < 1e9) return +(num / 1e6).toFixed(0) + 'M';
      if (num >= 1e9 && num < 1e12) return +(num / 1e9).toFixed(0) + 'B';
      if (num >= 1e12) return +(num / 1e12).toFixed(0) + 'T';
      return num;
    }
    return num;
  }
}
